<div class="TabBody">
  @if (product?.hasServiceSolution) {
    <!-- For IammProducts which is not in sameObject piciking from Product -->
    @if (((product?.iamppProducts) && product?.iamppProducts.length >0)) {
      <div class="cx-sorting top pdp-tab-heading-blue sorting-block">
        <div class="sorting-block">
          <div class="top-section-ui row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 pdp-tab-dd-label">
              <span class="pdp-tab-dd-label-title"> {{"common.text_iam_partNo" | cxTranslate}}</span>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
              <div class="row justify-content-end">
                <div class="pdp-sorting no-margin col-7 col-sm-9 col-md-7 col-lg-7">
                  <label for="pdp-select-part">{{"common.sort_by_pdp" | cxTranslate}}</label>
                  <select id="pdp-select-part" name="sort"
                    class="form-control pdp-select pdp-part-sort" [formControl]="sortControl"
                    (change)="sortControlValueChanged($event,true)">
                    <option value="code_asc">{{"common.pdp_part_partNum_asc" | cxTranslate}}
                    </option>
                    <option value="code_desc">{{"common.pdp_part_partNum_dsc" | cxTranslate}}
                    </option>
                    <option value="name_asc">{{"common.pdp_part_decs_asc" | cxTranslate}}
                    </option>
                    <option value="name_desc">{{"common.pdp_part_desc_dsc" | cxTranslate}}
                    </option>
                    <option value="typenumber_asc">{{"common.pdp_part_typeNum_asc" |
                    cxTranslate}}</option>
                    <option value="typenumber_desc">{{"common.pdp_part_typeNum_dsc" |
                    cxTranslate}}</option>
                  </select>
                </div>
                <div class="pdp-search no-margin col-1 col-sm-1 col-md-1 col-lg-1">
                  <a (click)="showIampSearch = !showIampSearch">
                    <img src="/icons/search-icon-white.svg" alt=""
                      class="search-icon" width="20" height="20" />
                    </a>
                  </div>
                  <div
                    class="no-padding mode-change  d-lg-flex product-view-btn col-1 col-md-1 col-lg-1 no-margin">
                    @if (!isMobile) {
                      <button class="btn cx-product-layout" [ngClass]="customViewModeIAMP === 'List'?'pdpGrid':'pdpList'"
                        (click)="CusTomchangeModeIAMP()" tabindex="0">
                        @if (customViewModeIAMP === 'Grid') {
                          <cx-icon [type]="iconTypes.LIST"></cx-icon>
                        }
                        @if (customViewModeIAMP === 'List') {
                          <cx-icon [type]="iconTypes.GRID"></cx-icon>
                        }
                      </button>
                    }
                  </div>
                  <div class="pdp-toggle no-margin col-1 col-md-1 col-lg-1">
                    <a (click)="showIampToggleResults = !showIampToggleResults">
                      <img [attr.src]="showIampToggleResults? '/icons/arrow-up-white.svg': '/icons/arrow_down-white.svg'"
                        alt="" class="search-icon" width="20" height="20" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                @if (showIampSearch) {
                  <div class="top-section-ui col-12 col-sm-12 justify-content-end">
                    <div class="col-10 col-sm-10 col-lg-10">
                      <input type="text" id="inputValue" class="form-control PDPSearch"
                        [formControl]="inputFormControl"
                        placeholder="{{'common.text_pdp_parthassol_search' | cxTranslate}}"
                        (keyup)="InputValueChanged($event,true)">
                        <div class="pdp-PDPSearchBox">
                          <img src="/icons/search.svg" alt="" class="search-icon"
                            width="20" height="20" />
                          </div>
                        </div>
                        <div class="col-1 col-sm-1 col-lg-1">
                          <a (click)="showIampSearch = !showIampSearch" class="sol-close-icon">
                            <img src="/icons/close_white.svg" alt="" class="close-icon" />
                          </a>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
              @if (showIampToggleResults) {
                <div id="product-results-list " class="cx-product-container pdp-tab-innerblock-toggle">
                  @if (customViewModeIAMP === 'Grid') {
                    <div class="row">
                      @for ( key of iampProductCopy; track  key) {
                        <app-pdp-tab-grid-item [product]="key"
                        class="col-12 col-sm-6 col-md-3 sm-view product-grid-item"></app-pdp-tab-grid-item>
                      }
                    </div>
                  }
                  @if (customViewModeIAMP === 'List') {
                    @for ( key of iampProductCopy; track  key) {
                      <app-pdp-tab-list-item [product]="key"
                      class="col-12 col-sm-6 col-md-3 "></app-pdp-tab-list-item>
                    }
                  }
                </div>
              }
            }
            @for (  key of getObjectKeys(product?.hasServiceSolution); track   key; let i = $index) {
              <div>
                @if ((key!='iamppProducts' && isArray(product?.hasServiceSolution[key],i)&& product?.hasServiceSolution[key].length > 0)) {
                  <div class="cx-sorting top pdp-tab-heading-blue sorting-block">
                    <div class="sorting-block">
                      <div class="top-section-ui row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 pdp-tab-dd-label">
                          @if (product?.hasServiceSolution[key+'Label']) {
                            <span class="pdp-tab-dd-label-title">
                            {{product?.hasServiceSolution[key+'Label']}}</span>
                          }
                          @if (!product?.hasServiceSolution[key+'Label']) {
                            <span> IAM Part No.</span>
                          }
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                          <div class="row justify-content-end">
                            <div class="pdp-sorting no-margin col-7 col-sm-9 col-md-7 col-lg-7">
                              <label for="pdp-select-part">{{"common.sort_by_pdp" | cxTranslate}}</label>
                              <select id="pdp-select-part" name="sort"
                                class="form-control pdp-select pdp-part-sort"
                                [formControl]="sortControl"
                                (change)="sortControlValueChanged($event,false,key)">
                                <option value="code_asc">{{"common.pdp_part_partNum_asc" | cxTranslate}}
                                </option>
                                <option value="code_desc">{{"common.pdp_part_partNum_dsc" |
                                cxTranslate}}</option>
                                <option value="name_asc">{{"common.pdp_part_decs_asc" | cxTranslate}}
                                </option>
                                <option value="name_desc">{{"common.pdp_part_desc_dsc" | cxTranslate}}
                                </option>
                                <option value="typenumber_asc">{{"common.pdp_part_typeNum_asc" |
                                cxTranslate}}</option>
                                <option value="typenumber_desc">{{"common.pdp_part_typeNum_dsc" |
                                cxTranslate}}</option>
                              </select>
                            </div>
                            <div class="pdp-search no-margin col-1 col-sm-1 col-md-1 col-lg-1">
                              <a (click)="showSearch[i] = !showSearch[i]">
                                <img src="/icons/search-icon-white.svg" alt=""
                                  class="search-icon" width="20" height="20" />
                                </a>
                              </div>
                              <div
                                class="no-padding mode-change d-lg-flex product-view-btn col-1 col-md-1 col-lg-1 no-margin">
                                @if (!isMobile) {
                                  <button class="btn cx-product-layout" [ngClass]="customViewModeIAMP === 'List'?'pdpGrid':'pdpList'"
                                    (click)="CusTomchangeModeIAMP()" tabindex="0">
                                    @if (customViewModeIAMP === 'Grid') {
                                      <cx-icon [type]="iconTypes.LIST"></cx-icon>
                                    }
                                    @if (customViewModeIAMP === 'List') {
                                      <cx-icon [type]="iconTypes.GRID"></cx-icon>
                                    }
                                  </button>
                                }
                              </div>
                              <div class="pdp-toggle no-margin col-1 col-md-1 col-lg-1">
                                <a (click)="showToggleResults[i] = !showToggleResults[i]">
                                  <img [attr.src]="showToggleResults[i]? '/icons/arrow-up-white.svg': '/icons/arrow_down-white.svg'"
                                    alt="" class="search-icon" width="20" height="20" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            @if (showSearch[i]) {
                              <div class="top-section-ui col-12 col-sm-12 justify-content-end">
                                <div class="col-10 col-sm-10 col-lg-10">
                                  <input type="text" id="inputValue" class="form-control PDPSearch"
                                    [formControl]="inputFormControl"
                                    placeholder="{{'common.text_pdp_parthassol_search' | cxTranslate}}"
                                    (keyup)="InputValueChanged($event,false,key)">
                                    <div class="pdp-PDPSearchBox">
                                      <img src="/icons/search.svg" alt="" class="search-icon"
                                        width="20" height="20" />
                                      </div>
                                    </div>
                                    <div class="col-1 col-sm-1 col-lg-1">
                                      <a (click)="showSearch[i] = !showSearch[i]" class="sol-close-icon">
                                        <img src="/icons/close_white.svg" alt=""
                                          class="close-icon" />
                                        </a>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            @if (showToggleResults[i]) {
                              <div id="product-results-list " class="cx-product-container pdp-tab-innerblock-toggle">
                                @if (customViewMode[i] === 'Grid') {
                                  <div class="row">
                                    @for ( key2 of productCopy[key]; track  key2) {
                                      <app-pdp-tab-grid-item
                                        [product]="key2?.target || key2"
                                      class="col-12 col-sm-6 col-md-3 sm-view product-grid-item"></app-pdp-tab-grid-item>
                                    }
                                  </div>
                                }
                                @if (customViewMode[i] === 'List') {
                                  @for ( key2 of productCopy[key]; track  key2) {
                                    <app-pdp-tab-list-item
                                      [product]="key2.target || key2"
                                    class="col-12 col-sm-6 col-md-3 "></app-pdp-tab-list-item>
                                  }
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
